import RenamePopover from "@/appComponents/Blocks/Composites/RenamePopover/RenamePopover";
import React from "react";
import { Button, isNullish } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { kebabCase } from "@/Utils/formatters";
import {
  getChartSettingsTestPrefix,
  ChartSettingsSectionRoutes
} from "@/providers/NavigationProvider";

const getFieldDisplayLabel = fieldID => {
  let displayField = null;
  switch (fieldID) {
    case "Location":
      displayField = "Location";
      break;
    case "First Name":
      displayField = "f_name";
      break;
    case "Last Name":
      displayField = "l_name";
      break;
    case "Preferred First":
      displayField = "preferredfirst";
      break;
    case "Preferred Last":
      displayField = "preferredlast";
      break;
    case "aTitle":
      displayField = "alternatetitle";
      break;
  }
  return isNullish(displayField) ? fieldID : appstr(displayField);
};

export const CustomMappingPopover = props => {
  const displayField = getFieldDisplayLabel(props.fieldID);
  const prefix = "custom-mapping";
  const reference = (
    <Button
      modifier={"secondary"}
      size={"medium"}
      tooltipProps={{ message: "Manually enter field name" }}
      dataTestId={`${prefix}-edit-btn-${props.fieldID}`}
      disabled={props?.disabled}
    >
      {appstr("Edit")}
    </Button>
  );
  return (
    <RenamePopover
      popoverProps={{
        reference: reference,
        options: { placement: "left" },
        disabled: props?.disabled
      }}
      name={props.currentField ?? ""}
      onCommit={newFieldName => props.onUpdate(props.fieldID, newFieldName)}
      validateFxn={newFieldName => props.validateFxn(props.fieldID, newFieldName)}
      dataTestPrefix={getChartSettingsTestPrefix(ChartSettingsSectionRoutes.Mapping)}
      fieldTestSuffix={kebabCase(props.fieldID)}
      inputProps={{
        inputOnly: false,
        label: `${displayField} ${appstr("Mapping")}`,
        placeholder: appstr("Enter field name"),
        id: `${prefix}-input-${props.fieldID}`
      }}
    />
  );
};
